import { openPopup } from '@passkeys/popup';
import { WindowTransport, RPC } from '@passkeys/rpc';

import { ALLOWED_ORIGINS } from '@/background/features/passkey/constants';
import { EMBEDDABLE_SIGNER } from '@/ui/constants';
import { referrerURL } from '@/utils/referrer';

export const getTransportWindow = async (): Promise<Window | null> => {
  // Order matters because embedded signer can be used in both modes.
  // Embeddable mode routes messages to its own window.
  if (EMBEDDABLE_SIGNER) {
    return window;
  }

  // Standalone mode should open popup and messages should be forwarded there.
  if (__STANDALONE_MODE__) {
    return openPopup({ target: __PASSKEYS_NETWORK_URL__ });
  }

  // Send messages to parent dapp on normal mode.
  return window.parent;
};

export const getModalTransportWindow = (): Window => {
  // For standalone, modalRpc should always talk to the window we're on.
  if (__STANDALONE_MODE__) {
    return window;
  }

  // Send messages to parent dapp on normal mode.
  return window.parent;
};

export const getTransportTarget = () => {
  // Order matters because embedded signer can be used in both modes.
  // On embeddable mode messages are targeted to window iteslf.
  if (EMBEDDABLE_SIGNER) {
    return window.location.origin;
  }

  // On standalone mode, messages target is always the signer itself (no intermediaries involved).
  if (__STANDALONE_MODE__) {
    return __PASSKEYS_NETWORK_URL__;
  }

  // On normal mode, messages are targeted to parent dapp.
  return referrerURL;
};

const getModalTransportTarget = () => {
  // On standalone mode, messages target is always the window itself.
  if (__STANDALONE_MODE__) {
    return window.location.origin;
  }

  // On normal mode, messages are targeted to parent dapp.
  return referrerURL;
};

export const createModalRpc = () => {
  const transport = new WindowTransport({
    allowedOrigins: ALLOWED_ORIGINS,
    window: getModalTransportWindow(),
    target: getModalTransportTarget(),
  });

  return new RPC({ transport, allowedOrigins: [__PASSKEYS_NETWORK_URL__] });
};
